import { Divider, FormControl, Grid, List, ListItem, ListItemText, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { If } from '../../common/IfComponent';
import { RootState } from '../../store';
import { fetchCustomerGroups, setSelectedCustomerGroup } from './redux/customerGroupSlices';
const mapStateToProps = (state: RootState) => ({
    customerGroups: state.customerGroups.customerGroups,
    selectedCustomerGroup: state.customerGroups.selectedCustomerGroup,
    customers: state.customers.customers
});

type Props = ReturnType<typeof mapStateToProps>;

const CustomerGroups = ({ customerGroups, selectedCustomerGroup, customers }: Props) => {
    const dispatch = useDispatch();
    const handleRowClick = (customerGroupId: number) => {
        dispatch(setSelectedCustomerGroup(customerGroupId));
    };
    const [customerFilter, setCustomerFilter] = useState('');
    const filteredCustomers = Object.values(customers).filter(
        c =>
            c.customerNumber?.toString().includes(customerFilter) ||
            c.name.toLowerCase().includes(customerFilter.toLowerCase())
    );
    useEffect(() => {
        dispatch(fetchCustomerGroups.request());
    }, [dispatch]);

    const handleSetCustomerFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCustomerFilter(event.target.value);
    };

    return (
        <Grid container>
            <Grid item md={3}>
                <List component="nav" dense disablePadding={true} aria-label="customer groups">
                    {Object.values(customerGroups).map(cg => {
                        return (
                            <ListItem
                                key={cg.customerGroupId}
                                button
                                selected={cg.customerGroupId === selectedCustomerGroup}
                                onClick={() => handleRowClick(cg.customerGroupId!)}
                            >
                                <ListItemText primary={cg.name} />
                            </ListItem>
                        );
                    })}
                </List>
            </Grid>
            <Divider orientation="vertical" flexItem />
            <If
                condition={selectedCustomerGroup !== null}
                then={
                    <Grid item>
                        <FormControl sx={{ paddingLeft: '16px' }}>
                            <TextField
                                value={customerFilter}
                                onChange={handleSetCustomerFilter}
                                label="Filter customer"
                                variant="standard"
                            />
                        </FormControl>

                        <List component="nav" dense disablePadding={true} aria-label="customers">
                            {filteredCustomers
                                .filter(c =>
                                    customerGroups[
                                        selectedCustomerGroup?.toString() ?? 0
                                    ]?.customerIds?.includes(c.customerId)
                                )
                                ?.map(c => (
                                    <ListItem key={c.customerId}>
                                        <ListItemText>
                                            {c.customerNumber} {c.name}
                                        </ListItemText>
                                    </ListItem>
                                ))}
                        </List>
                    </Grid>
                }
                else={null}
            />
        </Grid>
    );
};

export default connect(mapStateToProps)(CustomerGroups);
